import { render } from "./LoginInput.vue?vue&type=template&id=3bd03a54"
import script from "./LoginInput.vue?vue&type=script&lang=js"
export * from "./LoginInput.vue?vue&type=script&lang=js"
script.render = render

export default script